module.exports = __webpack_public_path__ + "img/skillsA-1.81fe6daa.png";